import type { SVGProps } from 'react';
const SvgMoreSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={4} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M4.278 2c0 .989-.846 1.79-1.89 1.79C1.347 3.79.5 2.989.5 2c0-.988.846-1.79 1.889-1.79S4.278 1.013 4.278 2M10.889 2c0 .989-.846 1.79-1.889 1.79S7.111 2.989 7.111 2c0-.988.846-1.79 1.889-1.79s1.889.802 1.889 1.79M17.5 2c0 .989-.846 1.79-1.889 1.79S13.722 2.989 13.722 2c0-.988.846-1.79 1.89-1.79C16.653.21 17.5 1.013 17.5 2"
    />
  </svg>
);
export default SvgMoreSettings;
